@if (stepView(); as view) {
  @if (isReadyToRender()) {
    @let rect = targetRect();
    @let position = calloutPosition();

    <div
      class="fixed inset-0 z-[200] pointer-events-none"
      (animate.enter)="onBackdropEnter($event)"
      (animate.leave)="onBackdropLeave($event)"
    >
      @if (rect) {
        <div
          class="spot-frame"
          [style.top.px]="0"
          [style.height.px]="rect.top"
          [style.left.px]="0"
          [style.right.px]="0"
        ></div>
        <div
          class="spot-frame"
          [style.top.px]="rect.bottom"
          [style.bottom.px]="0"
          [style.left.px]="0"
          [style.right.px]="0"
        ></div>
        <div
          class="spot-frame"
          [style.top.px]="rect.top"
          [style.height.px]="rect.height"
          [style.left.px]="0"
          [style.width.px]="rect.left"
        ></div>
        <div
          class="spot-frame"
          [style.top.px]="rect.top"
          [style.height.px]="rect.height"
          [style.left.px]="rect.right"
          [style.right.px]="0"
        ></div>
        <div
          class="spot-outline"
          [style.top.px]="rect.top"
          [style.left.px]="rect.left"
          [style.width.px]="rect.width"
          [style.height.px]="rect.height"
        ></div>
      } @else {
        <div class="spot-frame inset-0"></div>
      }

      <div
        class="tutorial-callout"
        (animate.enter)="onCalloutEnter($event)"
        [class.callout-centered]="!position"
        [style.top.px]="position?.top"
        [style.left.px]="position?.left"
      >
        <p class="type-label">{{ view.step.title }}</p>
        <p class="text-xs mt-[6px]">{{ view.step.body }}</p>
        <div class="flex items-center justify-between mt-[10px]">
          <span class="type-meta">
            @if (view.totalSteps !== 1) {
              Step {{ view.stepIndex + 1 }} of {{ view.totalSteps }}
            }
          </span>
          <div class="flex gap-2">
            @if (view.totalSteps !== 1) {
              <button
                type="button"
                class="btn btn-xs btn-neutral"
                (click)="skip()"
                appSfx="ui-click"
                [sfxTrigger]="['click', 'hover']"
              >
                Skip
              </button>
            }

            <button
              type="button"
              class="btn btn-xs btn-primary"
              (click)="next()"
              appSfx="ui-success"
              [sfxTrigger]="['click', 'hover']"
            >
              {{ view.stepIndex + 1 === view.totalSteps ? 'Done' : 'Next' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
}
